export default __webpack_public_path__ + "static/media/logo-with-text.f26e0798.svg";